var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordConfirm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 34,
    x: 4,
    y: 28,
    fill: "#f7d881",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78b75b",
    d: "M61 39l-3.31-.74A13.56 13.56 0 0149 32a13.56 13.56 0 01-8.69 6.26L37 39a28 28 0 0011.2 22.4l.8.6.8-.6A28 28 0 0061 39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96cc7f",
    d: "M43.86 57.35c8-2.16 14.14-9.46 15.74-18.66l-1.91-.43A13.56 13.56 0 0149 32a13.56 13.56 0 01-8.69 6.26L37 39a28 28 0 006.86 18.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c8d1",
    d: "M8 28h5V18a10 10 0 0120 0v10h5a4.09 4.09 0 011 .14V18a16 16 0 00-32 0v10.14A4.09 4.09 0 018 28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5b95b",
    d: "M2 36h12v18H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c8d1",
    d: "M25 46.55V38a2 2 0 00-2-2 2 2 0 00-2 2v8.55a4 4 0 104 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 47,
    r: 6,
    fill: "#ebf7fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 46v-8a3 3 0 00-6 0v8a5 5 0 001.81 8.84A5.37 5.37 0 0023 55a5 5 0 003-9zm-1.14 6.33a3 3 0 11-3.36-4.93 1 1 0 00.5-.87V38a1 1 0 012 0v8.55a1 1 0 00.5.87 3 3 0 01.36 4.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.22 38l-3.31-.73a12.63 12.63 0 01-8-5.8 1 1 0 00-1.72 0A12.55 12.55 0 0143 36.23V32a5 5 0 00-3-4.58V18a17 17 0 00-34 0v9.42A5 5 0 003 32v3H2a1 1 0 00-1 1v18a1 1 0 001 1h1v3a5 5 0 005 5h30a5 5 0 005-5v-.13a29.08 29.08 0 004.6 4.33l.8.6a1 1 0 001.2 0l.8-.6A29.15 29.15 0 0062 39a1 1 0 00-.78-1zM8 18a15 15 0 0130 0v9h-4v-9a11 11 0 00-22 0v9H8zm24 9H14v-9a9 9 0 0118 0zM13 37v4H3v-4zM3 53v-4h10v4zm10-6H3v-4h10zm28 11a3 3 0 01-3 3H8a3 3 0 01-3-3v-3h9a1 1 0 001-1V36a1 1 0 00-1-1H5v-3a3 3 0 013-3h30a3 3 0 013 3v5c-.3.09-.6.18-.91.25l-3.31.75a1 1 0 00-.78 1 29.14 29.14 0 005 16.24zm8.2 2.6l-.2.15-.2-.15A27.15 27.15 0 0138 39.8l2.51-.56A14.63 14.63 0 0049 33.79a14.63 14.63 0 008.48 5.45l2.52.56a27.15 27.15 0 01-10.8 20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.89 40.45l-1.78-.9-.68 1.35A7.09 7.09 0 1054 42.16zM54 47a5.05 5.05 0 11-2.47-4.29l-2.7 5.4-2-2.71-1.6 1.2 3 4a1 1 0 00.8.4h.09a1 1 0 00.8-.55l3.17-6.34A4.92 4.92 0 0154 47z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordConfirm);
export default __webpack_public_path__ + "static/media/passwordConfirm.9b9f7715.svg";
export { ForwardRef as ReactComponent };